import script from "./UiDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDataTable.vue?vue&type=script&setup=true&lang=js"

import "./UiDataTable.vue?vue&type=style&index=0&id=10fd7329&lang=scss"

const __exports__ = script;

export default __exports__